export default {
    name: {
        label: 'Name',
        placeholder: 'Name',
    },
    save: 'Save',
    cancel: 'Cancel',
    title: {
        update: 'Update file',
    },
    button: {
        save: 'Save',
        create: 'Create',
        edit: 'Edit',
        delete: 'Delete',
        upload: 'Upload',
    },
    error: {
        invalidFileName:
            'The file name should contain only alphabets, numbers, spaces, dot, underscore and dash',
    },
    success: {
        update: 'The file name has been updated',
        delete: 'The file has been deleted',
    },
    delete: {
        confirm: {
            title: 'Delete file',
            message: 'Are you sure to delete this file?',
        },
    },
    upload: {
        confirm: {
            fileExist: 'This file name is exist. Would you like to replace curennt file',
            title: 'Warrning upload file',
        },
    },
};
